function FormHeader({ title, subtitle = "Normann Olsen Skruefundament" }) {
  return (
    <div className="flex flex-col items-center justify-center bg-primary-light pt-8 pb-4 px-6 border-b border-gray-100">
      <img
        src={process.env.PUBLIC_URL + '/logo-octopus.png'}
        alt="Normann Olsen Skru fundament logo"
        className="h-20 mb-2 drop-shadow-md"
        style={{ objectFit: 'contain' }}
      />
      <h1 className="text-2xl md:text-3xl font-extrabold text-brand-black mb-1 text-center">{title}</h1>
      <p className="text-base text-brand-orange font-bold text-center">{subtitle}</p>
    </div>
  );
}

export default FormHeader;